import styled from "styled-components";

const MobileTopBarStyled = styled.header`
    background-color: ${props => props.theme.heritageGreen};
    height: 5.6rem;
    width: 100%;
    margin: 0;
    padding: 1.2rem 1.6rem;
	display: flex;

	.header__mobile-controls {
		min-height: auto;
	}

	.m59 {
		display: flex !important;
		z-index: 2;

		&__trigger {
        	background-color: inherit;

			span {
				margin-bottom: 0.5rem;
			}

			span:before {
				vertical-align: middle;
			}
    	}

		a {
			text-decoration: none;
		}
	}

	.header__basket {
		display: flex;
		align-items: center;
		justify-content: center;

		&, a {
			margin: 0;
		}

		a {
			background-position: center;
		}
	}

	.header__utility-search {
		margin-left: 0;
		width: 3rem;
		margin-right: 2.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 3rem;
		width: 3rem;
	}

	.header__mobile-controls {
		align-items: center;
	}

	.header__basket,
	.m59 {
		height: 3rem;
    	width: 3rem;
		margin-right: 2.4rem;
	}
`;

export { 
	MobileTopBarStyled
 };
